import * as types from '../mutation-types'
import * as expression from "../../data/base/expressions"
import FateFortuneStore from '../plugins/fatefortune'
import { API } from '../../api'
import { WS } from '../../websocket'
import { DISCUSS_DOM } from '../../dom'
import { SHARE } from '../../share'
import { DISCUSS_DATA_MANAGER } from '../../data'

export default {
    namespaced: true,
    modules: {
        fatefortune: FateFortuneStore
    },
    state: {
        detailInfo: {},
        gotLunPanList: false,
        lunpanList: [],
        isNewLunPan: false,
        hideName: false,
        hasLogined: false,
        curUserUid: 0,
        lunpanData: {},
        lunpanRefreshing: false,
        lunpanGetAll: false,
        lunpanNewestId: 0,
        lunpanHistoryList: [],
        expressionList: [],
        chatImagesList: [],
        showWSFailedPop: false,
        showDiscussEditPop: false
    },
    mutations: {
        [types.DISCUSS_CHAT_SEND_IMAGE](state, params) {
            console.log('types.DISCUSS_CHAT_SEND_IMAGE------', params, state.lunpanHistoryList);
            state.chatImagesList.push(params.localData);
            state.lunpanHistoryList.push({
                myself: true,
                type: 'image',
                content: params.localData
            });
        },
        [types.DISCUSS_CHAT_GET_WS_MESSAGE](state, data) {
            console.log('types.DISCUSS_CHAT_GET_WS_MESSAGE--------', data)
            state.lunpanHistoryList = DISCUSS_DATA_MANAGER.addHistoryListDataByData(state.lunpanHistoryList, data);
        },
        [types.DISCUSS_CHAT_SEND_MY_WS_MESSAGE](state, data) {
            console.log('types.DISCUSS_CHAT_SEND_MY_WS_MESSAGE--------', data)
            window._czc.push(["_trackEvent", "论盘模块", "论盘", "在论盘发信息"]);
            state.lunpanHistoryList = DISCUSS_DATA_MANAGER.addHistoryListDataByMyData(state.lunpanHistoryList, data);
        }
    },
    actions: {
        initLunPanList({state}, detailData) {
            
            state.detailInfo = detailData;
            if(state.gotLunPanList) { return; }

            API.getLunPanList({
                hid: detailData.id
            }, function(data){
                state.gotLunPanList = true;
                if(data.length == 0) { return; }
                console.log('获取论盘列表成功::::::', data);
                var newList = [];
                data.forEach(dd => {
                    var lunpanData = DISCUSS_DATA_MANAGER.getLunPanDataByData(dd);
                    newList.push(lunpanData);
                });
                state.lunpanList = newList;
                AppFate.$store.state.detail.baziNumData.lunpan = state.lunpanList.length;
            });
        },
        addNewLunPan({dispatch, state}, params) {
            API.addLunPan({
                hid: state.detailInfo.id,
                f_title: params.lunpanName
            }, function(data){
                // Todo here 引导分享微信or朋友圈邀请好友一起来论盘
                console.log('新增论盘成功::::::', data);
                window._czc.push(["_trackEvent", "论盘模块", "论盘", "新建论盘"]);

                state.isNewLunPan = true;
                // 更新列表数据的论盘状态
                dispatch('record/updateRecordListLunpanStatus', state.detailInfo.id, {root: true})
                dispatch('detail/updateDetailLunpanStatus', null, {root: true})
                var lunpanData = DISCUSS_DATA_MANAGER.getLunPanDataByData(data);
                state.lunpanList.push(lunpanData);
                AppFate.$store.state.detail.baziNumData.lunpan = state.lunpanList.length;
                if(params.cb && typeof(params.cb) == 'function') {
                    params.cb(lunpanData);
                }
            });
        },
        editLunPanData({commit, state}, params) {
            var newParams = _.omit(params, ['cb']);
            API.updateLunPan(newParams, function(data){
                if(data.ret){
                    console.log('修改论盘成功::::::', data)
                    state.lunpanList = DISCUSS_DATA_MANAGER.updateLunPanListDataTitle(state.lunpanList, params);
                    if(params.cb && typeof(params.cb) == 'function') {
                        setTimeout(() => {
                            params.cb();
                        }, 20);
                    }
                }
            });
        },
        deleteLunPanData({commit, state}, deleteId) {
            console.log('deleteLunPanData------', deleteId)
            API.deleteLunPan({
                id: deleteId
            }, function(data){
                if(data.ret) {
                    console.log('删除论盘成功::::::', data)
                    state.lunpanList = DISCUSS_DATA_MANAGER.deleteLunPanListData(state.lunpanList, deleteId);
                    AppFate.$store.state.detail.baziNumData.lunpan = state.lunpanList.length;
                }
            })
        },
        initLunPan({commit, state}, params) {
            // 拉取论盘聊天记录列表数据，并初始化websockt实时聊天
            console.log('initLunPan-----', state.lunpanHistoryList, params)
            state.lunpanData = params.lunpanData;
            state.lunpanHistoryList = [];
            
            API.getLunPanMsgList({
                rid: params.lunpanData.rid
            }, function(data){
                console.log('获取论盘消息记录列表成功::::::', data)
                window._czc.push(["_trackEvent", "论盘模块", "论盘", "查看论盘"]);

                state.hasLogined = true;
                if(data.length > 0) {
                    var resultData = DISCUSS_DATA_MANAGER.initHistoryListDataByList(state.lunpanHistoryList, data);
                    state.lunpanHistoryList = resultData.resultList;
                    state.lunpanNewestId = resultData.newestId;
                }
                if(params.cb && typeof(params.cb) == 'function') {
                    params.cb();
                }
            })
            state.expressionList = expression.CONST_EXPRESSION;
        },
        initShareLunPan({commit, state}, params) {
            state.detailInfo = params.detailData;
            // 暂存命盘数据
            AppFate.$store.state.detail.personInfo = params.detailData;
            AppFate.$store.dispatch('minifatefortune/initCommentMiniFateFortune', params.detailData);
            state.lunpanData = DISCUSS_DATA_MANAGER.getLunPanDataByData(params.lunpanData);
            state.lunpanHistoryList = [];

            window._czc.push(["_trackEvent", "论盘模块", "论盘", "查看分享的批盘"]);

            // 初始化IM
            WS.initWebSocket(params.lunpanData.rid, function(){
                // 拉取论盘聊天记录列表数据，并初始化websockt实时聊天
                console.log('initShareLunPan-----', state.lunpanHistoryList, params)
                API.getLunPanMsgList({
                    rid: params.lunpanData.rid
                }, function(data){
                    console.log('获取论盘消息记录列表成功::::::', data)
                    state.hasLogined = true;
                    if(data.length > 0) {
                        var resultData = DISCUSS_DATA_MANAGER.initHistoryListDataByList(state.lunpanHistoryList, data);
                        state.lunpanHistoryList = resultData.resultList;
                        state.lunpanNewestId = resultData.newestId;
                        setTimeout(() => {
                            DISCUSS_DOM.updateDiscussPageStyle();
                            DISCUSS_DOM.updateDiscussFormStyle();
                        }, 300);
                    }
                })
                state.expressionList = expression.CONST_EXPRESSION;
            }, function(){
                state.showWSFailedPop = true;
            });

            // 设置微信分享配置
            var fromEmbedded = AppFate.$store.state.embedded.fromEmbedded;
            setTimeout(() => {
                if(!fromEmbedded){
                    SHARE.initConfigShare();
                }
            }, 100);
        },
        refreshHistoryMsgList({state}) {
            // console.log('refreshHistoryMsgList-------', state.lunpanData, state.lunpanNewestId);
            // 如果是新论盘，不刷新:::Todo 方案可优化
            if(state.isNewLunPan) {
                state.isNewLunPan = false;
                state.lunpanRefreshing = false;
                state.lunpanGetAll = true;
                return;
            }
            API.getLunPanMsgList({
                rid: state.lunpanData.rid,
                id: state.lunpanNewestId
            }, function(data){
                console.log('刷新论盘消息记录列表成功:::::::', data)
                state.lunpanRefreshing = false;
                if(data.length > 0) {
                    var resultData = DISCUSS_DATA_MANAGER.initHistoryListDataByList(state.lunpanHistoryList, data);
                    state.lunpanHistoryList = resultData.resultList;
                    state.lunpanNewestId = resultData.newestId < state.lunpanNewestId ? resultData.newestId : state.lunpanNewestId;
                    setTimeout(() => {
                        DISCUSS_DOM.updateDiscussPageStyle();
                        DISCUSS_DOM.updateDiscussFormStyle();
                    }, 300);
                }else if(data.length == 0) {
                    console.log('state.lunpanGetAllstate.lunpanGetAll', state.lunpanGetAll)
                    state.lunpanGetAll = true;
                }
            })
        },
        getWSLogin({state}, data) {
            state.curUserUid = data.uid;
        },
        getWSMessage({commit}, data) {
            commit(types.DISCUSS_CHAT_GET_WS_MESSAGE, data);
            DISCUSS_DOM.updateDiscussHistoryListScrollStyle();
        },
        sendMyWSMessage({commit}, data) {
            commit(types.DISCUSS_CHAT_SEND_MY_WS_MESSAGE, data);
            DISCUSS_DOM.updateDiscussHistoryListScrollStyle();
        },
        chatSendImage({commit}, params) {
            commit(types.DISCUSS_CHAT_SEND_IMAGE, params);
        },
        resetData({state}) {
            state.detailInfo = {};
            state.gotLunPanList = false;
            state.lunpanList = [];
            state.isNewLunPan = false;
            state.hideName = false;
            state.hasLogined = false;
            state.curUserUid = 0;
            state.lunpanData = {};
            state.lunpanRefreshing = false;
            state.lunpanGetAll = false;
            state.lunpanNewestId = 0;
            state.lunpanHistoryList = [];
            state.expressionList = [];
            state.chatImagesList = [];
            state.showWSFailedPop = false;
            state.showDiscussEditPop = false;
        },
        resetLunPanData({state}) {
            state.isNewLunPan = false;
            state.hideName = false;
            state.hasLogined = false;
            state.curUserUid = 0;
            state.lunpanData = {};
            state.lunpanRefreshing = false;
            state.lunpanGetAll = false;
            state.lunpanNewestId = 0;
            state.lunpanHistoryList = [];
            state.expressionList = [];
            state.chatImagesList = [];
            state.showWSFailedPop = false;
            state.showDiscussEditPop = false;
        }
    }
}
